<template>
    <div class="uk-container uk-container-small">
        <div class="uk-card uk-card-default uk-card-body uk-width-1-1@m mt-5">
            <img src="https://firebasestorage.googleapis.com/v0/b/weni-281323.appspot.com/o/logo.png?alt=media&token=fa6a5538-547d-40e6-8bca-f1534ddbb413" />
            <div class=" uk-width-1-1@m">
                <span>Enregistrez votre commande</span>
                <form @submit.prevent="createColis">
                    <fieldset class="uk-fieldset">
                    <div class="uk-margin">
                        <input class="uk-input" type="text" v-model="commande.client_name" placeholder="Nom de l'expéditeur" required>
                    </div>
                    <div class="uk-margin">
                        <input class="uk-input" type="text" v-model="commande.depart_address" placeholder="Lieu de depart" required>
                    </div>
                    <div class="uk-margin">
                        <input class="uk-input" type="number" v-model="commande.client_phone" placeholder="Numéro de départ" required>
                    </div>
                    <div class="uk-margin">
                        <input class="uk-input" type="text" v-model="commande.dest_address" placeholder="Lieu du destinataire" required>
                    </div>
                    <div class="uk-margin">
                        <input class="uk-input" type="number" v-model="commande.dest_contact" placeholder="Numéro du destinataire" required>
                    </div>
                    <div class="uk-margin">
                        <input class="uk-input" type="text" v-model="commande.nature" placeholder="Nature du coli (express ou classic)" required> 
                    </div>
                    <div class="uk-margin">
                    <label>Tarifs de la livraison (en FCFA)</label>
                        <input class="uk-input" type="text" disabled v-model="commande.montant" placeholder="Exemple: 1 500 F" required>
                    </div>
                    <div class="uk-margin">
                    <label>Valeur de colis (en FCFA)</label>
                        <input class="uk-input" type="number" v-model="commande.valeur" placeholder="Exemple: 18 000 F" required>
                    </div>

                    </fieldset>
                    <div class="d-flex justify-content-center">
                            <button class="btn btn-round my-3 border-0 px-5" style="background-color:#FFAB0E; color:#fff;  font-size:1em !important; " >Enregistrer</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
  import { db, dbstore, auth } from '../../main';
  import Swal from "sweetalert2";
export default {
    data(){
        return{
            commande: {
                client_name: "",
                client_phone: "",
                colis_type: "envoi",
                created_at:"",
                depart_address:"",
                dest_address:"",
                dest_contact:"",
                id_colis:"",
                livreur_id:"",
                livreur_name:"Aucun livreur",
                montant:0,
                valeur:0,
                nature:"",
                categorie:"express",
                payment_method:"cash",
                statut:"attente"
            },
        }
        
    },
    methods: {
    createColis(event){
    
      const current = new Date();
      const date = current.getFullYear()+'-'+(current.getMonth()+1)+'-'+current.getDate();
      const time = current.getHours() + ":" + current.getMinutes() + ":" + current.getSeconds();
      const dateTime = date +' '+ time;
      const created_at = dateTime;
      const colis = db.ref('Colis Requetes').push({
        client_name: this.commande.client_name,
        client_phone: this.commande.client_phone,
        colis_type: "envoi",
        created_at:created_at,
        depart_address:this.commande.depart_address,
        dest_address:this.commande.dest_address,
        dest_contact:this.commande.dest_contact,
        id_colis:"",
        livreur_id:"",
        livreur_name: "",
        montant:Number(this.commande.montant),
        valeur:Number(this.commande.valeur),
        nature:this.commande.nature,
        payment_method:this.commande.payment_method,
        statut:this.commande.statut,
        categorie:this.commande.categorie,
      })
      db.ref('Colis Requetes').child(colis.key).child('id_colis').set(colis.key)
    //   this.$router.push({ path: "/admin/livraison/encours"});
      event.target.reset();
      event.preventDefault();
      Swal.fire({
        position: "center",
        icon: "success",
        title: "Commande enregistrée avec succès",
        showConfirmButton: true,
        timer: 4000,
        allowOutsideClick: false,
      });
    },
    }
}
</script>

<style>

img {
    width: 100px;
    height: 100px
}

span { 
    font-weight: bold;
    font-size: 1.5rem;
}

@media (max-width: 320px) {
    .uk-input {
        font-size: 14px;
    }

    span {
        font-size: 1rem;
    }

    label {
        font-size: 12px;
    }
}


</style>
